module.exports = __webpack_public_path__ + "static/media/Placeholder.fc88d354.png";